export default __webpack_public_path__ + "04341d218486b35b93c89e0f014ec24b.woff";